import { useSelector } from "react-redux";
import { AppState } from "store";
import { PeriodisationMode } from "models/utilTypes/periodisationTypes";
import { DateHelper } from "utils/helpers";

function usePeriodisationMinDate(mode: PeriodisationMode = "month") {
  const lockDate = useSelector((store: AppState) => store.auth.selectedCompany.lockDate);
  if (!lockDate) return undefined;
  const lockDateInFormat = new Date(lockDate);

  if (mode === "date") {
    return DateHelper.addDays(lockDateInFormat, 1);
  }

  return DateHelper.isLastDayofMonth(lockDateInFormat)
    ? DateHelper.getFirstDayOfNextMonth(lockDateInFormat)
    : DateHelper.getFirstDayOfMonth(lockDateInFormat);
}

export default usePeriodisationMinDate;
